import { useEffect } from 'react';

let lockCount = 0;
let savedScrollY = 0;
let savedBodyStyles = null;

const lockBodyScroll = () => {
    const body = document.body;

    if (lockCount === 0) {
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        savedBodyStyles = {
            overflow: body.style.overflow,
            position: body.style.position,
            top: body.style.top,
            left: body.style.left,
            right: body.style.right,
            width: body.style.width,
            touchAction: body.style.touchAction,
        };

        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${savedScrollY}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.touchAction = 'none';
    }

    lockCount += 1;
};

const unlockBodyScroll = () => {
    lockCount -= 1;

    if (lockCount === 0) {
        const body = document.body;

        body.style.overflow = savedBodyStyles.overflow;
        body.style.position = savedBodyStyles.position;
        body.style.top = savedBodyStyles.top;
        body.style.left = savedBodyStyles.left;
        body.style.right = savedBodyStyles.right;
        body.style.width = savedBodyStyles.width;
        body.style.touchAction = savedBodyStyles.touchAction;

        // Bootstrap sets `:root { scroll-behavior: smooth; }`, which would make
        // this restore ANIMATE from the top down to the saved position (visible
        // "auto-scrolling" flash after closing a sheet). Temporarily force
        // instant scrolling for the restore, then put the style back.
        const html = document.documentElement;
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, savedScrollY);
        html.style.scrollBehavior = prevScrollBehavior;
        savedBodyStyles = null;
    }
};

const useBodyScrollLock = (isLocked) => {
    useEffect(() => {
        if (!isLocked) return undefined;

        lockBodyScroll();
        return () => {
            unlockBodyScroll();
        };
    }, [isLocked]);
};

export default useBodyScrollLock;
